const imports = require("../../../lib");
module.exports = imports.google.protobuf;

const grpc = {};
grpc.web = require("grpc-web");
